/* =================== MENU MOBILE =================== */

$(function () {

  // Open / Close menu
  $("#menu-btn-mobile").on("click", function () {
    toggleNav();
  });

  // Fecha menu ao clicar em âncoras
  $('.cd-dropdown-content a[href^="#"]').on("click", function () {
    closeNav();
  });

  // Open submenu
  $(".has-children")
    .children("a")
    .on("click", function (event) {

      // Impede abrir âncora
      event.preventDefault();

      var selected = $(this);

      selected
        .next("ul")
        .removeClass("is-hidden")
        .end()
        .parent(".has-children")
        .parent("ul")
        .addClass("move-out");

      $(".cd-dropdown-content").scrollTop(0);
    });

  // Voltar submenu
  $(".go-back").on("click", function () {

    var selected = $(this);

    selected
      .parent("ul")
      .addClass("is-hidden")
      .parent(".has-children")
      .parent("ul")
      .removeClass("move-out");

    $(".cd-dropdown-content").scrollTop(0);
  });

  // Fecha clicando fora
  $(".cd-dropdown-wrapper").on("click", function (ev) {

    if (ev.target == this) {
      closeNav();
    }

  });

  // Fecha no swipe
  $("body").on("swipeleft", function () {
    closeNav();
  });

  // Toggle menu
  function toggleNav() {

    var navIsVisible = !$(".cd-dropdown").hasClass("dropdown-is-active");

    $(".cd-dropdown").toggleClass("dropdown-is-active", navIsVisible);

    $(".cd-dropdown-trigger").toggleClass(
      "dropdown-is-active",
      navIsVisible
    );

    $(".cd-dropdown-wrapper").toggleClass("active");

    $("#menu-btn-mobile").toggleClass("active", navIsVisible);

    if (!navIsVisible) {

      $(".cd-dropdown").one(
        "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
        function () {

          $(".has-children ul").addClass("is-hidden");
          $(".move-out").removeClass("move-out");

        }
      );

    }

  }

  // Open menu
  function openNav() {

    $(".cd-dropdown").addClass("dropdown-is-active");

    $(".cd-dropdown-trigger").addClass("dropdown-is-active");

    $(".cd-dropdown-wrapper").addClass("active");

    $("#menu-btn-mobile").addClass("active");

  }

  // Close menu
  function closeNav() {

    $(".cd-dropdown").removeClass("dropdown-is-active");

    $(".cd-dropdown-trigger").removeClass("dropdown-is-active");

    $(".cd-dropdown-wrapper").removeClass("active");

    $("#menu-btn-mobile").removeClass("active");

    $(".has-children ul").addClass("is-hidden");

    $(".move-out").removeClass("move-out");

  }

});